
import Vue from "vue";
import { Component } from "vue-property-decorator";
import ElementsList from "@/components/Add/ElementsList.vue";
import DesignLibraryModal from "@/components/Add/library/DesignLibraryModal.vue";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";
import { closeUiPanel } from "@/lib/panels/panels";
import { configStore, uiStore } from "@/store/store-accessor";

@Component({
  components: {
    DesignLibraryModal,
    PanelHeader,
    ElementsList
  }
})
export default class Add extends Vue {
  close() {
    closeUiPanel("add");
  }

  openDesignLibrary() {
    uiStore.setDesignLibraryModalState(true);
  }

  get state() {
    return configStore.elementsLoadingState;
  }
}
